import { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import SearchProvider from "../Provider/SearchProvider";

const Meta = ({ slug }) => {
  const { seoData, getSeoData } = useContext(SearchProvider);
  // Fetch SEO data on mount if not already loaded
  useEffect(() => {
    if (!seoData || seoData.length === 0) {
      getSeoData();
    }
  }, [seoData, getSeoData]);
  // Find the correct data by matching the slug
  const metaData = seoData?.find((item) => item.slug === slug);
  // Default values in case no match is found or data is still loading
  const title = metaData ? metaData.meta_title : "Bio ALign";
  const description = metaData
    ? metaData.meta_description
    : "Bio Align";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={title} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
    </Helmet>
  );
};

export default Meta;
